import { useState } from "react";
import { Sparkles } from "lucide-react";

const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

const TEMPLATES = [
  {
    id: "meme",
    label: "Meme",
    color: "#FF3E9D",
    tag: "Pure chaos energy",
    theme: "meme",
    supply: "1,000,000,000",
    names: [
      { name: "Moon Goblin", ticker: "GOBLIN" },
      { name: "Sigma Toad", ticker: "TOAD" },
      { name: "Crying Cat", ticker: "CRYCAT" },
      { name: "Chad Hamster", ticker: "CHAMST" },
    ],
    pitch: "No utility. No roadmap. Just vibes, memes, and a community that refuses to sell.",
  },
  {
    id: "community",
    label: "Community",
    color: "#00D4FF",
    tag: "Built by the people",
    theme: "meme",
    supply: "100,000,000",
    names: [
      { name: "Tribe Token", ticker: "TRIBE" },
      { name: "Squad Coin", ticker: "SQUAD" },
      { name: "The Collective", ticker: "COLLECT" },
      { name: "Homies Fund", ticker: "HOMIE" },
    ],
    pitch: "A coin owned by its community — holders vote on everything, tips fund the treasury, and every member shares the upside.",
  },
  {
    id: "utility",
    label: "Utility",
    color: "#CFFF04",
    tag: "Actually does something",
    theme: "utility",
    supply: "10,000,000",
    names: [
      { name: "PayFlow", ticker: "FLOW" },
      { name: "DataVault", ticker: "VAULT" },
      { name: "GridWork", ticker: "GRID" },
      { name: "LinkForge", ticker: "FORGE" },
    ],
    pitch: "A utility token powering real payments, access, and rewards inside our product — hold it, use it, earn it.",
  },
];

/** One-tap presets that pre-fill the entire builder. */
export default function VibeTemplates({ setForm }) {
  const [active, setActive] = useState(null);

  const apply = (t) => {
    const n = pick(t.names);
    setActive(t.id);
    setForm((f) => ({
      ...f,
      name: n.name,
      ticker: n.ticker.slice(0, 8),
      supply: t.supply,
      theme: t.theme,
      description: t.pitch,
    }));
  };

  return (
    <div className="mb-8" data-testid="vibe-templates">
      <div className="flex items-center gap-2 mb-3">
        <Sparkles size={12} className="text-[#cfff04]" />
        <span className="text-sm text-[#e2e2e2]">
          <span className="font-semibold text-white">Quick start:</span> tap a vibe and everything fills in
        </span>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {TEMPLATES.map((t) => (
          <button
            key={t.id}
            onClick={() => apply(t)}
            data-testid={`vibe-${t.id}`}
            className={`border p-3 sm:p-4 text-left transition-all group ${
              active === t.id
                ? "border-[#cfff04] bg-[#cfff04]/5"
                : "border-[#3a3a3a] bg-[#121212] hover:border-[#555]"
            }`}
          >
            <span className="block w-3 h-3 mb-2 sm:mb-3" style={{ background: t.color }} />
            <span className="font-display text-sm font-bold uppercase block">{t.label}</span>
            <span className="hidden sm:block text-sm text-[#c4c4c4] group-hover:text-[#e2e2e2]">
              {t.tag}
            </span>
          </button>
        ))}
      </div>
      {active && (
        <p className="mt-2 text-sm text-[#00ff41]" data-testid="vibe-applied">
          ✓ Pre-filled — tweak anything below, or tap again for a fresh name
        </p>
      )}
    </div>
  );
}
